import React, { Component, createRef } from "react";
import { Card } from "reactstrap";
import {
  Typography,
  Input as InputAntd,
  notification,
  Modal,
  Button,
  Select,
  Tag,
  Dropdown,
  Tooltip,
  Badge,
  message,
} from "antd";
import {
  CheckCircleOutlined,
  DownloadOutlined,
  UploadOutlined,
  CheckOutlined,
  FileAddOutlined,
  MessageOutlined,
  WalletOutlined,
  TruckOutlined,
  ShopOutlined,
  SendOutlined,
  ExpandAltOutlined,
  AudioOutlined,
  PlusOutlined,
  ArrowLeftOutlined,
  PictureOutlined,
  FileOutlined,
  EyeInvisibleOutlined,
  ArrowDownOutlined,
  FireFilled,
  CheckCircleFilled,
  SearchOutlined,
} from "@ant-design/icons";
import { PanelHeader } from "components";
import moment from "moment";
import { MessageBox, ChatItem, Avatar } from "react-chat-elements";
import "react-chat-elements/dist/main.css";
import saturninoAvatar from "../../assets/img/nadubot/saturnino.png";
import humanAvatar from "../../assets/img/nadubot/human-assistant.png";
import bgChat from "../../assets/img/nadubot/chat-bg-transparent.png";
import SystemMessageComponent from "./SystemMessage";
import FiltersDrawer from "./FiltersDrawer";
import ModalAttachment from "./ModalAttachment";
import ImageMessageBox from "./components/ImageMessageBox";
import FileMessageBox from "./components/FileMessageBox";
import AudioMessageBox from "./components/AudioMessageBox";
import TemplateMessageModal from "./TemplateMessageModal";
import LoadingView from "./components/LoadingView";
import NewChatModal from "./components/NewChatModal";
import sound from "../../assets/notifiaction.wav";
import { assistant, session_id } from "../../utils/axios/assistant";
import { backoffice } from "../../utils/axios/backoffice";
import { getAllEmployees } from "./utils/getAllEmployees";
import CustomerSettings from "./CustomerSettings";
import { getTemplateMessages } from "../../views/Customers/utils/whatsapp";
import {
  getConversationList,
  getNewConversationList,
  getRequiresAttentionList,
} from "./utils/conversations";
import LocationMessageBox from "./components/LocationMessageBox";
import ContactMessageBox from "./components/ContactMessageBox";
const { TextArea, Search } = InputAntd;

const filtersIS = {
  forceRefetch: false,
  searchbar: "",
  departments: ["welcome", "commercial", "technician", "billing"],
  selectedButton: "all",
  onlyCurrentUser: "",
  addParamUser: "",
};

class NaduChat extends Component {
  constructor(props) {
    super(props);
    let currentCustomer = null;
    try {
      currentCustomer = this.props.mainState.user.uuid;
    } catch (error) {
      console.error("No se pudo obtener el usuario: ", error);
    }
    this.state = {
      filters: filtersIS,
      conversations: {
        hasMorePages: true,
        page: 1,
        ids: [],
        fullList: [],
        importantList: [],
        filteredImportantList: [],
      },
      btnLoading: {
        takeOverChat: false,
      },
      customerSettings: {
        open: false,
      },
      allEmployees: {},
      sendingMessageLoading: false,
      mainLoading: true,
      isFullPage: false,
      fetching: {
        clients: false,
        messages: false,
      },
      customer: currentCustomer,
      selectedUser: undefined,
      filter: "",
      clients: [],
      filteredClients: [],
      newMessage: "",
      usersConversations: {},
      isModalOpen: false,
      showDrawerModal: false,
      openModalAttachment: false,
      openTemplatesModal: false,
      selectedOrigin: "",
      openNewChatModal: false,
      templates: [],
      attachmentType: "",
      selectedDepartment: "",
      menuOpen: false,
      openDropdown: false,
      last_timestamp: "",
      isAtBottom: true,
      transferUser: {
        loading: false,
        owner: "human",
        owner_id: "",
        is_local_owner: false,
        department: "welcome",
        client_id: null,
        redirection_context: "",
      },
      isTablet: window.innerWidth < 1024,
      isMobile: window.innerWidth < 768,
    };
    moment.locale("es");
    this.handleFilterButtonChange = this.handleFilterButtonChange.bind(this);
    this.handleOpenTransferModal = this.handleOpenTransferModal.bind(this);
    this.handleOpenDrawerModal = this.handleOpenDrawerModal.bind(this);
    this.getDepartmentColor = this.getDepartmentColor.bind(this);
    this.handleClientSelect = this.handleClientSelect.bind(this);
    this.handleContactClick = this.handleContactClick.bind(this);
    this.fetchUserMessages = this.fetchUserMessages.bind(this);
    this.handleSendMessage = this.handleSendMessage.bind(this);
    this.fetchUserFile = this.fetchUserFile.bind(this);
    this.dateFormatter = this.dateFormatter.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.takeOverChat = this.takeOverChat.bind(this);
    this.sendToFullScreen = this.sendToFullScreen.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.extractIdFromPath = this.extractIdFromPath.bind(this);
    this.loadData = this.loadData.bind(this);
    this.handleBackButton = this.handleBackButton.bind(this);
    this.firstLoad = this.firstLoad.bind(this);
    this.updateisTablet = this.updateisTablet.bind(this);
    this.refetchContacts = this.refetchContacts.bind(this);
    this.refetchConversation = this.refetchConversation.bind(this);
    this.changeToUnread = this.changeToUnread.bind(this);
    this.cleanCurrentConversation = this.cleanCurrentConversation.bind(this);
    this.listContentShow = this.listContentShow.bind(this);
    this.handleFiltersChange = this.handleFiltersChange.bind(this);
    this.handleOpenChange = this.handleOpenChange.bind(this);
    this.messagesEndRef = createRef();
    this.messagesContainerRef = createRef();
  }
  async componentDidMount() {
    window.addEventListener("resize", this.updateisTablet);
    if (this.messagesContainerRef.current) {
      this.messagesContainerRef.current.addEventListener(
        "scroll",
        this.handleRefScroll
      );
    }
    if (!("Notification" in window)) {
      message.error("El navegador no soporta notificaciones");
    } else if (
      Notification.permission !== "granted" &&
      Notification.permission !== "denied"
    ) {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          new Audio(sound).play();
          new Notification("Notificaciones activadas correctamente");
        }
      });
    }

    const allEmployees = await getAllEmployees();
    const urlParams = window.location.pathname.split("/");
    const isFullPage = urlParams[1] === "chat";
    const newFilters = {
      ...this.state.filters,
      ...JSON.parse(localStorage.getItem("filters")),
      addParamUser: urlParams[isFullPage ? 2 : 3]
        ? urlParams[isFullPage ? 2 : 3]
        : "",
    };

    this.setState({ isFullPage, allEmployees, filters: newFilters });
    localStorage.setItem("filters", JSON.stringify(newFilters));
    await this.firstLoad(urlParams[isFullPage ? 2 : 3]);
    getTemplateMessages().then((res) => this.setState({ templates: res.data }));
    this.intervalContacts = setInterval(() => this.refetchContacts(), 10000);
    this.intervalConversation = setInterval(() => {
      if (!this.state.fetching.messages) this.refetchConversation();
    }, 2000);
    this.scrollToBottomChat();
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateisTablet);
    if (this.messagesContainerRef.current) {
      this.messagesContainerRef.current.removeEventListener(
        "scroll",
        this.handleRefScroll
      );
    }
    clearInterval(this.intervalContacts);
    clearInterval(this.intervalConversation);
  }
  async firstLoad(hasSelectedUser = null) {
    const clientsList = await this.loadData();
    if (clientsList) {
      let userId = this.state.selectedUser;
      if (hasSelectedUser && !userId) {
        const client = clientsList.find(
          (client) => client.documentId === hasSelectedUser
        );
        userId = client ? client.id : userId;
        this.setState({ selectedUser: userId });
      }
      userId && (await this.handleClientSelect(userId));
    }
    this.setState({ mainLoading: false });
  }
  /* Refetch de contact-list si hay nueva información */
  refetchContacts = async () => {
    const { fetching, last_timestamp, conversations, filters } = this.state;
    if (fetching.clients) {
      return;
    }
    try {
      this.setState({ fetching: { ...fetching, clients: true } });
      const conversationsList = await getNewConversationList({
        ...filters,
        last_timestamp,
        conversationIds: conversations.ids,
      });

      const newList = conversationsList.changes
        ? conversationsList.data.filter((conver) => !conver.requires_attention)
        : conversations.fullList;

      const requiresAttentionList = await getRequiresAttentionList();

      const newClientsList = [...requiresAttentionList, ...newList];
      const pendingConversations =
        conversationsList.data &&
        conversationsList.data.filter((conver) => conver.isRead === false);

      if (
        conversationsList.changes &&
        Notification.permission !== "denied" &&
        pendingConversations.length > 0
      ) {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            new Audio(sound)
              .play()
              .catch((error) =>
                console.error("No se pudo reproducir el sonido:", error)
              );
            new Notification("naduchat", {
              icon: "https://nadunet.es/wp-content/uploads/2024/11/logo-u-nadunet.jpg",
              badge:
                "https://nadunet.es/wp-content/uploads/2024/11/logo-u-nadunet.jpg",
              image:
                "https://nadunet.es/wp-content/uploads/2024/11/logo-u-nadunet.jpg",
              body: `Hay mensajes nuevos por responder!`,
            });
          }
        });
      }

      this.setState({
        clients: newClientsList,
        filteredClients: newClientsList,
        last_timestamp: conversationsList.changes
          ? conversationsList.last_timestamp
          : last_timestamp,
        conversations: {
          ...this.state.conversations,
          ids: conversationsList.changes
            ? conversationsList.conversationIds
            : conversations.ids,
          fullList: newList,
          importantList: requiresAttentionList,
          filteredImportantList: requiresAttentionList,
        },
        fetching: { ...fetching, clients: false },
      });
      this.handleFiltersChange({ forceRefetch: false });
    } catch (error) {
      this.setState({ fetching: { ...fetching, clients: false } });
      console.error("error: ", error);
    }
  };
  /* Refetch de conversación si hay nueva información */
  refetchConversation = async () => {
    const { selectedUser, clients, fetching, usersConversations } = this.state;
    const foundClient = clients.find((client) => client.id === selectedUser);
    if (!foundClient || fetching.messages) return;
    try {
      const res = await assistant.get(
        `/new-messages/${usersConversations[selectedUser].messages[usersConversations[selectedUser].messages.length - 1].id}`
      );
      if (res.data && res.data.ok && res.data.changes) {
        let newMessages = res.data.data;
        const userConvo = this.state.usersConversations[selectedUser] || {
          messages: [],
          currentPage: 1,
          lastMessagesCounter: 0,
        };
        const previosMessages =
          userConvo.messages.length > 0
            ? userConvo.messages.map((message) => message.documentId)
            : [];
        if (previosMessages.length > 0) {
          newMessages = newMessages.filter(
            (message) => !previosMessages.includes(message.documentId)
          );
        }
        const allMessages = [...userConvo.messages, ...newMessages].sort(
          (message1, message2) => {
            let timestamp1 = message1.timestamp;
            let timestamp2 = message2.timestamp;

            if (typeof timestamp1 === "string")
              timestamp1 = parseInt(timestamp1);
            if (typeof timestamp2 === "string")
              timestamp2 = parseInt(timestamp2);

            const isMilliseconds1 = timestamp1.toString().length > 10;
            const momment1 = isMilliseconds1
              ? moment(timestamp1)
              : moment.unix(timestamp1);
            const isMilliseconds2 = timestamp2.toString().length > 10;
            const momment2 = isMilliseconds2
              ? moment(timestamp2)
              : moment.unix(timestamp2);

            return momment1.isBefore(momment2) ? -1 : 1;
          }
        );
        this.setState({
          usersConversations: {
            ...this.state.usersConversations,
            [selectedUser]: {
              ...userConvo,
              messages: allMessages,
              currentPage:
                newMessages.length >= 20
                  ? userConvo.currentPage + 1
                  : userConvo.currentPage,
              lastMessagesCounter: res.data.data.length,
            },
          },
        });
      }
    } catch (error) {
      console.error("error: ", error);
    }
  };
  handleFiltersChange = (newFilters) => {
    const { filters } = this.state;
    const updatedFilters = { ...filters, ...newFilters };
    this.setState({ filters: updatedFilters });
    localStorage.setItem("filters", JSON.stringify(updatedFilters));
  };
  handleOpenChange = (open) => {
    this.setState({ openDropdown: open });
  };
  handleFilterButtonChange = (filter) => {
    const { filters } = this.state;
    const updatedFilters = { ...filters, selectedButton: filter };

    this.setState({ filters: updatedFilters });
    localStorage.setItem("filters", JSON.stringify(updatedFilters));
    // this.handleDrawerFilters();
  };
  loadData = async () => {
    const { fetching, conversations, selectedUser, filters } = this.state;
    if (fetching.clients) {
      return;
    }
    try {
      this.setState({ fetching: { ...fetching, clients: true } });

      const requiresAttentionList = await getRequiresAttentionList();
      const conversationsList = await getConversationList(
        filters,
        conversations.page
      );

      const newClientsList = [
        ...requiresAttentionList,
        ...conversationsList.data,
      ];
      const newSelectedUser = newClientsList.find(
        (elem) =>
          elem.id === selectedUser || elem.documentId === filters.addParamUser
      );

      this.setState({
        conversations: {
          ...this.state.conversations,
          ids: conversationsList.conversationIds,
          fullList: conversationsList.data,
          importantList: requiresAttentionList,
          filteredImportantList: requiresAttentionList,
          hasMorePages: true,
          // hasMorePages: conversationsList.data.length % 20 === 0,
        },
        selectedUser: newSelectedUser ? newSelectedUser.id : null,
        last_timestamp: conversationsList.last_timestamp,
        clients: newClientsList,
        filteredClients: newClientsList,
        fetching: { ...fetching, clients: false },
      });
      return newClientsList;
    } catch (error) {
      this.setState({ fetching: { ...fetching, clients: false } });
      console.error("error: ", error);
    }
  };
  loadNewContactsPage = async () => {
    const { fetching, conversations, selectedUser, filters } = this.state;
    if (fetching.clients) {
      return;
    }
    try {
      this.setState({ fetching: { ...fetching, clients: true } });

      const newPage = conversations.page + 1;
      const conversationsList = await getConversationList(filters, newPage);

      const newClientsList = [
        ...conversations.fullList,
        ...conversationsList.data,
      ];
      const conversationIds = [
        ...conversations.ids,
        ...conversationsList.conversationIds,
      ];

      const newSelectedUser = newClientsList.find(
        (elem) =>
          elem.id === selectedUser || elem.documentId === filters.addParamUser
      );

      this.setState({
        conversations: {
          ...this.state.conversations,
          page: newPage,
          ids: conversationIds,
          fullList: newClientsList,
          hasMorePages: true,
          // hasMorePages: newClientsList.length % 20 === 0,
        },
        selectedUser: newSelectedUser ? newSelectedUser.id : null,
        clients: newClientsList,
        filteredClients: newClientsList,
        fetching: { ...fetching, clients: false },
      });
      return newClientsList;
    } catch (error) {
      this.setState({ fetching: { ...fetching, clients: false } });
      console.error("error: ", error);
    }
  };
  handleContactClick = async (client) => {
    await this.handleClientSelect(client.id);
    this.scrollToBottomChat();
    this.handleFiltersChange({ addParamUser: client.documentId });
    window.history.pushState(
      {},
      "",
      `${this.state.isFullPage ? "/chat" : "/backoffice/naduchat"}/${client.documentId}`
    );
  };
  handleClientSelect = async (userId) => {
    const { fetching, conversations } = this.state;
    this.setState({ fetching: { ...fetching, messages: true } });
    try {
      const updatedImportantClients = conversations.importantList.map(
        (client) => {
          if (client.id === userId && client.isRead === false) {
            assistant.put(`/change-to-read/${userId}`);
            return { ...client, isRead: true };
          } else return client;
        }
      );
      const updatedClients = conversations.fullList.map((client) => {
        if (client.id === userId && client.isRead === false) {
          assistant.put(`/change-to-read/${userId}`);
          return { ...client, isRead: true };
        } else return client;
      });

      this.setState({
        fetching: { ...fetching, clients: true },
        selectedUser: userId,
        clients: updatedClients,
        filteredClients: updatedClients,
        conversations: {
          ...conversations,
          importantList: updatedImportantClients,
          fullList: updatedClients,
        },
      });
      if (!this.state.usersConversations[userId]) {
        await this.fetchUserMessages(userId, false);
      } else {
        await this.refetchConversation();
      }
      this.scrollToBottomChat();
      this.setState({ fetching: { ...fetching, messages: false } });
    } catch (error) {
      this.setState({ fetching: { ...fetching, messages: false } });
    }
  };
  fetchUserMessages = async (userId, firstPage) => {
    try {
      const res = await assistant.get(
        `/conversation-messages/${userId}?page=${firstPage ? 1 : this.state.usersConversations[userId] ? this.state.usersConversations[userId].currentPage : 1}`
      );
      this.setState((prevState) => {
        const userConvo = prevState.usersConversations[userId] || {
          messages: [],
          currentPage: 1,
          lastMessagesCounter: 0,
        };
        if (res && res.data && res.data.data.length > 0) {
          let newMessages = res.data.data;
          const previosMessages =
            userConvo.messages.length > 0
              ? userConvo.messages.map((message) => message.documentId)
              : [];
          if (previosMessages.length > 0) {
            newMessages = newMessages.filter(
              (message) => !previosMessages.includes(message.documentId)
            );
          }
          const allMessages = [...userConvo.messages, ...newMessages].sort(
            (message1, message2) => {
              let timestamp1 = message1.timestamp;
              let timestamp2 = message2.timestamp;

              if (typeof timestamp1 === "string")
                timestamp1 = parseInt(timestamp1);
              if (typeof timestamp2 === "string")
                timestamp2 = parseInt(timestamp2);

              const isMilliseconds1 = timestamp1.toString().length > 10;
              const momment1 = isMilliseconds1
                ? moment(timestamp1)
                : moment.unix(timestamp1);
              const isMilliseconds2 = timestamp2.toString().length > 10;
              const momment2 = isMilliseconds2
                ? moment(timestamp2)
                : moment.unix(timestamp2);

              return momment1.isBefore(momment2) ? -1 : 1;
            }
          );
          return {
            usersConversations: {
              ...prevState.usersConversations,
              [userId]: {
                ...userConvo,
                messages: allMessages,
                currentPage:
                  res.data.data.length >= 20
                    ? userConvo.currentPage + 1
                    : userConvo.currentPage,
                lastMessagesCounter: res.data.data.length,
              },
            },
          };
        } else {
          return {
            usersConversations: {
              ...prevState.usersConversations,
              [userId]: {
                ...userConvo,
                currentPage: userConvo.currentPage,
                lastMessagesCounter: 0,
              },
            },
          };
        }
      });
    } catch (error) {
      console.error("error: ", error);
    }
  };
  handleOpenTransferModal = () => {
    this.setState({ isModalOpen: true });
  };
  handleToggleModalAttachment = (openModal, type) => {
    this.setState({ openModalAttachment: openModal, attachmentType: type });
  };
  handleToggleTemplatesModal = (openModal, department, origin = "") => {
    this.setState({
      openTemplatesModal: openModal,
      selectedDepartment: department,
      selectedOrigin: origin,
    });
  };
  handleMessageChange = (event) => {
    this.setState({ newMessage: event.target.value });
  };
  handleSendMessage = async () => {
    try {
      this.setState({ sendingMessageLoading: true });
      const { clients, selectedUser, newMessage, customer } = this.state;
      const selectedClient = clients.find(
        (client) => client.id === selectedUser
      );
      const res = await assistant.post(`/send-message`, {
        message: {
          type: "text",
          data: newMessage,
        },
        conversation_id: selectedClient && selectedClient.id,
        client_phone: selectedClient && selectedClient.contact.phone,
        employee_id: customer,
      });
      if (res && res.data && res.data.ok) {
        this.setState({ newMessage: "", sendingMessageLoading: false });
        this.refetchContacts();
        await this.refetchConversation();
        this.scrollToBottomChat();
      } else {
        notification.error({
          message: "Message Failed",
          description: "Ha ocurrido un error al enviar el mensaje.",
        });
        this.setState({ sendingMessageLoading: false });
      }
    } catch (error) {
      console.error("error: ", error);
      notification.error({
        message: "Error",
        description: "Ha ocurrido un error al enviar el mensaje.",
      });
      this.setState({ sendingMessageLoading: false });
    }
  };
  handleScroll = async () => {
    const { selectedUser, fetching } = this.state;
    const { scrollTop, scrollHeight } = this.messagesContainerRef.current;
    if (scrollTop === 0 && !fetching.messages) {
      this.setState({ fetching: { ...this.state.fetching, messages: true } });
      const previousScrollHeight = scrollHeight;
      await this.fetchUserMessages(selectedUser, false);
      const newScrollHeight = this.messagesContainerRef.current.scrollHeight;
      this.messagesContainerRef.current.scrollTop =
        newScrollHeight - previousScrollHeight;
      this.setState({ fetching: { ...this.state.fetching, messages: false } });
    }
  };
  handleBackButton = () => {
    const { history } = this.props;
    const currentPath = window.location.pathname;
    const newPath = currentPath.substring(0, currentPath.lastIndexOf("/"));
    this.setState({ selectedUser: null });

    history.push(newPath);
  };
  cleanCurrentConversation = () => {
    const { history } = this.props;
    const currentPath = window.location.pathname;
    const match = currentPath.match(/^\/(chat|naduChat)\/[^/]+$/);
    if (match) {
      const newPath = `/${match[1]}`;
      this.setState({ selectedUser: null });
      history.push(newPath);
    }
  };

  dateFormatter(timestamp) {
    if (typeof timestamp === "string") timestamp = parseInt(timestamp);
    const isMilliseconds = timestamp.toString().length > 10;
    const date = isMilliseconds ? moment(timestamp) : moment.unix(timestamp);
    const now = moment();

    const isToday = date.isSame(now, "day");
    const isYesterday = date.isSame(now.clone().subtract(1, "days"), "day");
    const isThisWeek = date.isSame(now, "week");

    if (isToday) {
      return `${date.format("HH:mm")}`;
    } else if (isYesterday) {
      return `Ayer ${date.format("HH:mm")}`;
    } else if (isThisWeek) {
      return `${date.format("dddd HH:mm")}`;
    } else {
      return `${date.format("DD/MM HH:mm")}`;
    }
  }

  async transferUser() {
    try {
      const { transferUser, selectedUser } = this.state;
      this.setState({
        transferUser: {
          ...this.state.transferUser,
          loading: true,
        },
      });
      let res;
      if (transferUser.redirection_context.trim() === "") {
        notification.error({
          message: "Error",
          description: "Debes añadir un contexto.",
        });
        this.setState({
          transferUser: {
            ...this.state.transferUser,
            loading: false,
          },
        });
      } else if (transferUser.owner === "bot") {
        res = await assistant.post(`/redirect-bot`, {
          department: transferUser.department,
          client_id: selectedUser,
          redirection_context: transferUser.redirection_context, //
        });
      } else {
        res = await assistant.post(`/change-owner`, {
          owner: transferUser.owner,
          client_id: selectedUser,
          owner_id: "",
          is_local_owner: false,
          redirection_context: transferUser.redirection_context,
          department: transferUser.department,
        });
      }
      if (res && res.data && res.data.ok) {
        this.setState({
          isModalOpen: false,
          transferUser: {
            loading: false,
            owner: "human",
            owner_id: "",
            is_local_owner: false,
            department: "welcome 2",
            client_id: null,
            redirection_context: "",
          },
        });
        // this.loadData();
        notification.success({
          message: "Transferencia realizada",
          description:
            "La conversación ha sido transferida al nuevo propietario.",
        });
      }
    } catch (error) {
      this.setState({
        isModalOpen: false,
        transferUser: {
          ...this.state.transferUser,
          loading: false,
        },
      });
      console.error("error: ", error.message);
      notification.error({
        message: "Error",
        description: "Ha ocurrido un error al transferir la conversación.",
      });
    }
  }
  async closeChat(user_id) {
    try {
      const res = await assistant.put(`/close-conversation/${user_id}`, {});

      if (res && res.data && res.data.ok) {
        this.handleFiltersChange({ forceRefetch: true });
        this.refetchContacts();
        notification.success({
          message: "Chat cerrado",
          description: "La conversación fue finalizada correctamente.",
        });
      }
    } catch (error) {
      console.error(error.message);
      notification.error({
        message: "Error",
        description: "Ha ocurrido un error al marcar el chat como finalizado.",
      });
    }
  }
  async takeOverChat(user_id) {
    try {
      const { transferUser, btnLoading } = this.state;
      this.setState({ btnLoading: { ...btnLoading, takeOverChat: true } });
      const res = await assistant.post(`/change-owner`, {
        owner: "human",
        owner_id: this.props.mainState.user.uuid,
        is_local_owner: false,
        department: transferUser.department,
        client_id: user_id,
        redirection_context: `El usuario ${this.props.mainState.user.name} tomó el control de la conversación.`,
      });
      if (res && res.data && res.data.ok) {
        notification.success({
          message: "Conversación asignada",
          description: `La conversación ha sido asignada a ${this.props.mainState.user.name}`,
        });
        this.handleFiltersChange({ forceRefetch: true });
        this.refetchContacts();
      }
    } catch (error) {
      console.error("error: ", error.message);
      notification.error({
        message: "Error",
        description: "Ha ocurrido un error al asignarte la conversación.",
      });
    }
    this.setState({
      btnLoading: { ...this.state.btnLoading, takeOverChat: false },
    });
  }
  async putOutFire(user_id) {
    try {
      const res = await assistant.put(`/change-requires-attention/${user_id}`);
      if (res && res.data && res.data.ok) {
        this.handleFiltersChange({ forceRefetch: true });
        this.refetchContacts();
        this.cleanCurrentConversation();
      }
    } catch (error) {
      console.error(error.message);
      notification.error({
        message: "Error",
        description: "Ha ocurrido un error al apagar el chat.",
      });
    }
  }
  async changeToUnread(user_id) {
    try {
      const res = await assistant.put(`/change-to-unread/${user_id}`);
      if (res && res.data && res.data.ok) {
        this.cleanCurrentConversation();
        this.handleFiltersChange({ forceRefetch: true });
        this.refetchContacts();
      }
    } catch (error) {
      console.error("Error changing to unread: ", error.message);
    }
  }
  async chatActions(btn_key, user_id) {
    switch (btn_key) {
      case "takeOver":
        this.takeOverChat(user_id);
        break;
      case "transfer":
        this.setState({ isModalOpen: true });
        break;
      case "close":
        this.closeChat(user_id);
        break;
      case "putOutFire":
        this.putOutFire(user_id);
        break;
      case "changeToUnread":
        this.changeToUnread(user_id);
        break;
      default:
        console.warn(`Acción desconocida: ${btn_key}`);
    }
  }
  listContentShow = (last_message, customer) => {
    const getPrefix = () => {
      switch (last_message.owner) {
        case "client":
          return "Cliente: ";
        case "nadubot":
          return "Saturnino: ";
        case "nadunet":
          if (last_message.owner_id === customer) return "Tú: ";
          return "Nadunet: ";
        case "system":
          return "Sistema: ";
        default:
          return "Desconocido: ";
      }
    };
    switch (last_message.type) {
      case "text":
        return getPrefix() + last_message.content;
      case "audio":
        return getPrefix() + "🎵 Mensaje de audio";
      case "photo":
        return getPrefix() + "📷 Foto";
      case "file":
        return getPrefix() + "📎 Archivo";
      case "location":
        return getPrefix() + "📍 Ubicación";
      case "contact":
        return getPrefix() + "👤 Contacto";
      default:
        console.warn(`Acción desconocida: ${last_message.type}`);
        return getPrefix() + last_message.content;
    }
  };

  handleOpenDrawerModal = (boolean) => {
    this.setState({ showDrawerModal: boolean });
  };
  extractIdFromPath = (path) => {
    const naduchatMatch = path.match(/\/naduchat\/([^/]+)/);
    const chatMatch = path.match(/\/chat\/([^/]+)/);

    if (naduchatMatch) return naduchatMatch[1];
    if (chatMatch) return chatMatch[1];
    return null;
  };
  updateisTablet = () => {
    this.setState({ isTablet: window.innerWidth < 1024 });
    this.setState({ isMobile: window.innerWidth < 768 });
  };
  toggleMenu = () => {
    this.setState({ menuOpen: !this.state.menuOpen });
  };
  getDepartmentColor(department) {
    switch (department) {
      case "welcome":
        return "#4CAF50";
      case "welcome 2":
        return "#4CAF50";
      case "commercial":
        return "#2196F3";
      case "technician":
        return "#FFC107";
      default:
        return "gray";
    }
  }
  async fetchUserFile(file_id, message_id, download = false) {
    try {
      const { usersConversations, selectedUser } = this.state;
      const { data } = await assistant.get(`/contact-file/${file_id}`);

      if (data && data.ok) {
        const file = data.data.data;
        const file_name = data.data.file_name;

        this.setState({
          usersConversations: {
            ...usersConversations,
            [selectedUser]: {
              ...usersConversations[selectedUser],
              messages: usersConversations[selectedUser].messages.map((msg) => {
                if (msg.id === message_id) {
                  return { ...msg, file, file_name };
                } else {
                  return msg;
                }
              }),
            },
          },
        });

        if (download) {
          const anchorElement = document.createElement("a");
          anchorElement.href = file;
          anchorElement.download = file_name;
          anchorElement.click();
        }
      }
    } catch (error) {
      console.error("fetchUserFile error: ", error.message);
    }
  }
  handleRefScroll = () => {
    const container = this.messagesContainerRef.current;
    if (container) {
      const isScrolledToBottom =
        container.scrollTop + container.clientHeight >=
        container.scrollHeight * 0.9;

      this.setState({ isAtBottom: isScrolledToBottom });
    }
  };
  scrollToBottomChat = () => {
    if (this.messagesContainerRef.current) {
      this.messagesContainerRef.current.scrollTop =
        this.messagesContainerRef.current.scrollHeight;
    }
  };
  sendToFullScreen = () => {
    const currentPath = window.location.pathname;
    const prefix = "naduchat/";
    const index = currentPath.indexOf(prefix);

    if (index !== -1) {
      const uniqueId = currentPath.substring(index + prefix.length);
      window.open(`/chat/${uniqueId}`, "_blank");
    } else {
      window.open("/chat", "_blank");
    }
  };
  render() {
    const {
      allEmployees,
      selectedUser,
      newMessage,
      usersConversations,
      customer,
      openTemplatesModal,
      openModalAttachment,
      attachmentType,
      selectedDepartment,
      mainLoading,
      openNewChatModal,
      isAtBottom,
      sendingMessageLoading,
      isTablet,
      isMobile,
      selectedOrigin,
      conversations,
      filters,
      openDropdown,
    } = this.state;
    const selectedClient =
      [...conversations.importantList, ...conversations.fullList].length > 0 &&
      [...conversations.importantList, ...conversations.fullList].find(
        (client) => client.id === selectedUser
      );
    const isBotOwner =
      selectedClient &&
      selectedClient.chat_owner &&
      selectedClient.chat_owner.owner === "bot";
    const isCurrentUserOwner =
      selectedClient &&
      selectedClient.chat_owner &&
      selectedClient.chat_owner.owner_id === customer;
    const isChatClosed =
      selectedClient &&
      selectedClient.conversation_status &&
      selectedClient.conversation_status.slug === "closed";
    if (mainLoading) {
      return <LoadingView />;
    }
    return (
      <div>
        <CustomerSettings
          onClose={() => {
            this.setState({
              customerSettings: {
                ...this.state.customerSettings,
                open: false,
              },
            });
          }}
          isOpen={this.state.customerSettings.open}
          selectedClient={selectedClient}
          refetchContacts={this.refetchContacts}
          handleFiltersChange={this.handleFiltersChange}
        />
        <FiltersDrawer
          handleOpenDrawerModal={this.handleOpenDrawerModal}
          loadData={this.loadData}
          handleFiltersChange={this.handleFiltersChange}
          showDrawerModal={this.state.showDrawerModal}
          employee_id={customer}
          filters={this.state.filters}
        />
        <ModalAttachment
          openModal={openModalAttachment}
          type={attachmentType}
          handleToggleModalAttachment={this.handleToggleModalAttachment}
          selectedClient={selectedClient}
          employee_id={customer}
        />
        <TemplateMessageModal
          templates={this.state.templates}
          openModal={openTemplatesModal}
          department={selectedDepartment}
          handleToggleTemplatesModal={this.handleToggleTemplatesModal}
          dateFormatter={this.dateFormatter}
          selectedClient={selectedClient}
          employee={this.props.mainState.user}
          origin={selectedOrigin}
        />
        <NewChatModal
          templates={this.state.templates}
          openModal={openNewChatModal}
          handleClose={() => this.setState({ openNewChatModal: false })}
          dateFormatter={this.dateFormatter}
          employee={this.props.mainState.user}
        />
        <Modal
          closable={false}
          keyboard={false}
          maskClosable={false}
          open={this.state.isModalOpen}
          title="¿Deseas transferir la conversación?"
          confirmLoading={this.state.transferUser.loading}
          onOk={() => this.transferUser()}
          onCancel={() =>
            this.setState({
              isModalOpen: false,
              transferUser: {
                loading: false,
                owner: "human",
                owner_id: "",
                is_local_owner: false,
                department: "welcome 2",
                client_id: null,
                redirection_context: "",
              },
            })
          }
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div>
              <Typography>Departamento</Typography>
              <Select
                defaultValue={this.state.transferUser.department}
                onChange={(value) =>
                  this.setState({
                    transferUser: {
                      ...this.state.transferUser,
                      department: value,
                    },
                  })
                }
                style={{ width: 200 }}
              >
                <Select.Option value="welcome">Recepción</Select.Option>
                <Select.Option value="commercial">Comercial</Select.Option>
                <Select.Option value="billing">Facturación</Select.Option>
                <Select.Option value="technician">
                  Soporte técnico
                </Select.Option>
              </Select>
            </div>
            <div>
              <Typography>Asistente</Typography>
              <Select
                defaultValue={this.state.transferUser.owner}
                onChange={(value) =>
                  this.setState({
                    transferUser: {
                      ...this.state.transferUser,
                      owner: value,
                    },
                  })
                }
                style={{ width: 200 }}
              >
                <Select.Option value="human">Operador</Select.Option>
                <Select.Option value="bot">Saturnino</Select.Option>
              </Select>
            </div>
          </div>
          <div style={{ marginTop: "8px" }}>
            <Typography>Contexto</Typography>
            <TextArea
              value={this.state.transferUser.redirection_context}
              onChange={(event) =>
                this.setState({
                  transferUser: {
                    ...this.state.transferUser,
                    redirection_context: event.target.value,
                  },
                })
              }
              placeholder="Descripción de la conversación, aclarar motivo y datos importantes del cliente."
              autoSize={{ minRows: 3, maxRows: 5 }}
            />
          </div>
        </Modal>
        {!this.state.isFullPage && (
          <PanelHeader
            content={
              <div className="header text-center">
                <h2 className="title">naduchat</h2>
                <Button
                  type="primary"
                  icon={<ExpandAltOutlined />}
                  onClick={() => this.sendToFullScreen()}
                >
                  Abrir en pantalla completa
                </Button>
              </div>
            }
          />
        )}
        <div className="content" style={{ width: "100%" }}>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyItems: "center",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Card style={{ height: "100vh", margin: 0 }}>
              <div
                style={{
                  display: "flex",
                  padding: "0px",
                  height: "100%",
                  width: "100%",
                }}
              >
                <div
                  className={`chats-container ${selectedUser && isTablet && usersConversations[selectedUser]
                    ? "d-none"
                    : ""
                    }`}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "row",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        marginBottom: "30px",
                        gap: 8,
                      }}
                    >
                      <p
                        style={{
                          fontSize: "20px",
                          fontWeight: "bold",
                          color: "black",
                          margin: 0,
                        }}
                      >
                        {this.state.isFullPage ? "naduchat" : "Chats"}
                      </p>
                      <Tooltip title="Crear chat">
                        <Button
                          size="small"
                          shape="circle"
                          icon={<PlusOutlined />}
                          onClick={() =>
                            this.setState({ openNewChatModal: true })
                          }
                          style={{ fontSize: "12px" }}
                        />
                      </Tooltip>
                    </div>
                    <Button
                      style={{
                        marginBottom: "10px",
                      }}
                      // shape="round"
                      onClick={() => this.handleOpenDrawerModal(true)}
                    >
                      Filtros
                    </Button>
                  </div>
                  <Search
                    placeholder="Introduce el nombre o móvil del cliente"
                    value={filters.searchbar}
                    className="rounded-input"
                    prefix={<SearchOutlined />}
                    onChange={(event) =>
                      this.handleFiltersChange({
                        searchbar: event.target.value,
                      })
                    }
                    onSearch={this.loadData}
                    enterButton="Buscar"
                    allowClear
                    style={{ marginBottom: "10px" }}
                  />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginBottom: "10px",
                      gap: "5px",
                      paddingRight: "5px",
                      paddingLeft: "5px",
                      overflowX: "auto",
                      scrollbarWidth: "thin",
                      msOverflowStyle: "thin",
                    }}
                  >
                    <Button
                      shape="round"
                      className="nadubot-custom-btn"
                      type={filters.selectedButton === "all" && "primary"}
                      onClick={() => this.handleFilterButtonChange("all")}
                    >
                      Todos
                    </Button>
                    <div
                      className="nadubot-custom-avatar"
                      id={
                        filters.selectedButton === "bot"
                          ? "nadubot-custom-btn-selected"
                          : "nadubot-custom-btn"
                      }
                      onClick={() => this.handleFilterButtonChange("bot")}
                    >
                      <img src={saturninoAvatar} alt="" />
                    </div>
                    <Button
                      shape="round"
                      className="nadubot-custom-btn"
                      type={filters.selectedButton === "toManage" && "primary"}
                      onClick={() => this.handleFilterButtonChange("toManage")}
                    >
                      Por gestionar
                    </Button>
                    <Button
                      shape="round"
                      className="nadubot-custom-btn"
                      type={filters.selectedButton === "managed" && "primary"}
                      onClick={() => this.handleFilterButtonChange("managed")}
                    >
                      Gestionados
                    </Button>
                  </div>
                  <div
                    style={{
                      flex: "1",
                      overflowY: "scroll",
                      scrollbarWidth: "thin",
                      msOverflowStyle: "thin",
                    }}
                  >
                    {[
                      ...conversations.importantList,
                      ...conversations.fullList,
                    ].map((client) => (
                      <Dropdown
                        key={client.id}
                        onClick={async () => this.handleContactClick(client)}
                        placement="bottom"
                        menu={{
                          items: [
                            //btn_key = takeOver / transfer / close

                            {
                              label: "Marcar como no leído",
                              key: "changeToUnread",
                              disabled: !client.isRead,
                              icon: <EyeInvisibleOutlined />,
                              onClick: ({ key }) =>
                                this.chatActions(key, client.id),
                            },
                            {
                              label: client.requires_attention
                                ? "Apagar incendio"
                                : "Prender fuego",
                              key: "putOutFire",
                              icon: <FireFilled />,
                              onClick: ({ key }) =>
                                this.chatActions(key, client.contact.id),
                            },
                            {
                              type: "divider",
                            },
                            {
                              label: "Tomar conversación",
                              key: "takeOver",
                              disabled:
                                !client.isBotOwner || client.isChatClosed,
                              icon: <DownloadOutlined />,
                              onClick: ({ key }) =>
                                this.chatActions(key, client.id),
                            },
                            {
                              type: "divider",
                            },
                            {
                              label: "Transferir cliente",
                              key: "transfer",
                              disabled:
                                client.isBotOwner || client.isChatClosed,
                              icon: <UploadOutlined />,
                              onClick: ({ key }) =>
                                this.chatActions(key, client.id),
                            },
                            {
                              type: "divider",
                            },
                            {
                              label: "Cerrar chat",
                              key: "close",
                              danger: true,
                              disabled:
                                client.isBotOwner || client.isChatClosed,
                              icon: <CheckCircleOutlined />,
                              onClick: ({ key }) =>
                                this.chatActions(key, client.id),
                            },
                          ],
                        }}
                        trigger={["contextMenu"]}
                      >
                        <div
                          style={{
                            display: "flex",
                            position: "relative",
                            flexDirection: "row",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              borderLeft: `4px solid ${this.getDepartmentColor(client.chat_owner && client.chat_owner.department)}`,
                            }}
                          ></div>
                          {client.requires_attention && (
                            <div
                              style={{
                                position: "absolute",
                                left:
                                  client.chat_owner &&
                                    client.chat_owner.owner === "human"
                                    ? "18px"
                                    : "20px",
                                zIndex: 10,
                              }}
                            >
                              <FireFilled
                                style={{ color: "rgb(255, 94, 94)" }}
                              />
                            </div>
                          )}

                          <ChatItem
                            className={` ${client.id === selectedUser ? "selectedChat" : ""}`}
                            avatar={
                              client.chat_owner &&
                                client.chat_owner.owner === "human"
                                ? client.chat_owner.picture &&
                                  !client.chat_owner.picture.endsWith(
                                    "pictures/"
                                  )
                                  ? client.chat_owner.picture
                                  : humanAvatar
                                : saturninoAvatar
                            }
                            alt="avatar"
                            title={
                              <div className="chatitem-title">
                                {client.contact.client_id && (
                                  <CheckCircleFilled
                                    style={{
                                      color: "#01b182",
                                      marginRight: "4px",
                                    }}
                                  />
                                )}
                                {client.contact.name
                                  ? client.contact.name
                                  : client.contact.phone
                                    ? "+" + client.contact.phone
                                    : "Desconocido"}
                              </div>
                            }
                            subtitle={
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span
                                  style={{
                                    width: "70%",
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {client.last_message
                                    ? this.listContentShow(
                                      client.last_message,
                                      customer
                                    )
                                    : "No hay mensaje."}
                                </span>
                                <span
                                  style={{
                                    width: "28%",
                                    textAlign: "center",
                                  }}
                                >
                                  <Tag
                                    style={{
                                      width: "100%",
                                      textAlign: "center",
                                      overflow: "hidden",
                                      whiteSpace: "nowrap",
                                      textOverflow: "ellipsis",
                                    }}
                                    color={
                                      client.conversation_status &&
                                        client.conversation_status.hex_code
                                        ? client.conversation_status.hex_code
                                        : "#E3E36A"
                                    }
                                  >
                                    {client.conversation_status &&
                                      client.conversation_status.public_name
                                      ? client.conversation_status.public_name
                                      : "Sin estado"}
                                  </Tag>
                                </span>
                              </div>
                            }
                            dateString={
                              <div>
                                <span
                                  style={
                                    !client.isRead
                                      ? {
                                        color: "#46b98a",
                                        fontWeight: "bold",
                                        marginRight: 4,
                                      }
                                      : client.requires_attention
                                        ? {
                                          color: "rgb(255, 94, 94)",
                                          fontWeight: "bold",
                                          marginRight: 4,
                                        }
                                        : {}
                                  }
                                >
                                  {client.last_message
                                    ? this.dateFormatter(
                                      client.last_message.timestamp
                                    )
                                    : "Sin mensaje"}
                                </span>
                                {!client.isRead && (
                                  <Badge color="#46b98a" size="large" />
                                )}
                              </div>
                            }
                            id={client.id}
                          />
                        </div>
                      </Dropdown>
                    ))}
                    {conversations.hasMorePages && (
                      <div
                        style={{
                          width: "100%",
                          marginTop: "10px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Button
                          type="primary"
                          shape="round"
                          icon={<PlusOutlined />}
                          // loading={this.state.btnLoading.takeOverChat}
                          onClick={this.loadNewContactsPage}
                        >
                          Cargar más
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
                <div
                  className={`conversation-container ${isTablet ? "d-flex w-full" : ""
                    }`}
                >
                  {selectedUser && usersConversations[selectedUser] && (
                    <div
                      style={{
                        flex: "0 0 auto",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        backgroundColor: "#f0f2f5",
                        height: "60px",
                        justifyContent: "space-between",
                      }}
                      className={`${isMobile ? "pad-small" : "pad-default"}`}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        {isTablet && (
                          <Button
                            shape="circle"
                            icon={<ArrowLeftOutlined />}
                            style={{ marginRight: "6px", fontSize: "14px" }}
                            className={isTablet ? "mr-2" : ""}
                            size={isMobile ? "medium" : "large"}
                            onClick={() => this.handleBackButton()}
                          />
                        )}
                        <div>
                          <Avatar
                            src={
                              selectedClient &&
                                selectedClient.chat_owner &&
                                selectedClient.chat_owner.owner === "human"
                                ? selectedClient.chat_owner.picture ||
                                humanAvatar
                                : saturninoAvatar
                            }
                            alt="avatar"
                            type="circle"
                            className={`${isMobile ? "w-small-avatar" : "w-default-avatar"}`}
                            onError={(e) => {
                              e.currentTarget.src = humanAvatar;
                              return false;
                            }}
                          />
                        </div>

                        <div
                          style={{
                            paddingLeft: "6px",
                            marginBottom: "0px",
                            display: "flex",
                            flexDirection: "column",
                            width: isMobile ? "fit-content" : "auto",
                          }}
                          className={` ${isMobile ? "padl-2" : ""}`}
                        >
                          <h5
                            style={{ marginBottom: "0px", cursor: "pointer" }}
                            onClick={() => {
                              this.setState({
                                customerSettings: {
                                  ...this.state.customerSettings,
                                  open: true,
                                },
                              });
                            }}
                            className={`${isMobile ? "font-sm" : ""}`}
                          >
                            {selectedClient && selectedClient.contact
                              ? selectedClient.contact.name
                                ? selectedClient.contact.name
                                : selectedClient.contact.phone
                                  ? "+" + selectedClient.contact.phone
                                  : "Desconocido"
                              : "Desconocido"}
                          </h5>
                          <p
                            style={{ marginBottom: "0px" }}
                            className={`${isMobile ? "font-xs" : ""}`}
                          >
                            {selectedClient &&
                              (selectedClient.chat_owner &&
                                selectedClient.chat_owner.owner === "bot"
                                ? "Atendido por Saturnino"
                                : selectedClient.chat_owner &&
                                  selectedClient.chat_owner.owner_id
                                  ? "Atendido por " + selectedClient.chat_owner &&
                                  selectedClient.chat_owner.fullname
                                  : "No está siendo atendido")}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <Tooltip
                          placement="bottom"
                          title={"Transferir conversación"}
                        >
                          <Button
                            type="primary"
                            shape="circle"
                            disabled={isBotOwner || isChatClosed}
                            icon={<UploadOutlined />}
                            size={isMobile ? "medium" : "large"}
                            onClick={() =>
                              this.chatActions("transfer", selectedClient)
                            }
                            style={{ marginRight: "6px", fontSize: "14px" }}
                          />
                        </Tooltip>
                        <Tooltip placement="bottom" title={"Cerrar chat"}>
                          <Button
                            shape="circle"
                            disabled={isBotOwner || isChatClosed}
                            icon={<CheckOutlined />}
                            size={isMobile ? "medium" : "large"}
                            style={{ fontSize: "14px" }}
                            onClick={() =>
                              this.chatActions("close", selectedClient.id)
                            }
                          />
                        </Tooltip>
                      </div>
                    </div>
                  )}
                  <div
                    style={{
                      flexGrow: 1,
                      overflowY: "auto",
                      height: "520px",
                      padding: selectedUser ? "6px" : "0px",
                      scrollbarWidth: "thin",
                      msOverflowStyle: "thin",
                      backgroundColor: "#f3f0ea", // #efeae2
                      backgroundImage: selectedUser && `url(${bgChat})`,
                      backgroundRepeat: "repeat",
                      backgroundSize: "contain",
                      backgroundSize: "auto",
                    }}
                    ref={this.messagesContainerRef}
                    onScroll={this.handleScroll}
                  >
                    {selectedUser && usersConversations[selectedUser] ? (
                      <div>
                        {usersConversations[selectedUser].messages.map(
                          (msg, index) => {
                            function formatMessage(input) {
                              // Reemplazar los _ por <i> y </i>
                              let formattedMessage = input.replace(
                                /_(.*?)_/g,
                                "<i>$1</i>"
                              );
                              // Reemplazar los * por <strong> y </strong>
                              formattedMessage = formattedMessage.replace(
                                /\*(.*?)\*/g,
                                "<strong>$1</strong>"
                              );
                              // Reemplazar los \n por <br>
                              formattedMessage = formattedMessage.replace(
                                /\n/g,
                                "<br>"
                              );
                              return formattedMessage;
                            }
                            if (msg.owner === "system") {
                              return (
                                <SystemMessageComponent
                                  key={"system_" + index}
                                  msg={msg}
                                  index={index}
                                  dateFormatter={this.dateFormatter}
                                />
                              );
                            } else {
                              if (msg.type === "text") {
                                return (
                                  <MessageBox
                                    key={"text_" + index}
                                    position={
                                      msg.owner === "client" ? "left" : "right"
                                    }
                                    title={
                                      msg.owner === "client"
                                        ? undefined
                                        : msg.owner === "nadunet"
                                          ? allEmployees[msg.owner_id]
                                            ? allEmployees[msg.owner_id].name
                                            : msg.owner
                                          : msg.owner
                                    }
                                    type={"text"}
                                    text={
                                      msg.content ? (
                                        <span
                                          dangerouslySetInnerHTML={{
                                            __html: formatMessage(msg.content),
                                          }}
                                        />
                                      ) : (
                                        ""
                                      )
                                    }
                                    dateString={this.dateFormatter(
                                      msg.timestamp
                                    )}
                                    className={`message-container ${msg.owner === "nadubot" ? "naduBotText" : msg.owner === "nadunet" ? "nadunetText" : "clientText"}`}
                                  />
                                );
                              } else if (msg.type === "photo") {
                                return (
                                  <ImageMessageBox
                                    key={"image_" + index}
                                    msg={msg}
                                    fetchUserFile={this.fetchUserFile}
                                    dateFormatter={this.dateFormatter}
                                  />
                                );
                              } else if (msg.type === "file") {
                                return (
                                  <FileMessageBox
                                    key={"file_" + index}
                                    msg={msg}
                                    fetchUserFile={this.fetchUserFile}
                                    dateFormatter={this.dateFormatter}
                                  />
                                );
                              } else if (msg.type === "audio") {
                                return (
                                  <AudioMessageBox
                                    key={"audio_" + index}
                                    msg={msg}
                                    fetchUserFile={this.fetchUserFile}
                                    dateFormatter={this.dateFormatter}
                                  />
                                );
                              } else if (msg.type === "location") {
                                return (
                                  <LocationMessageBox
                                    msg={msg}
                                    dateFormatter={this.dateFormatter}
                                  />
                                );
                              } else if (msg.type === "contact") {
                                return (
                                  <ContactMessageBox
                                    msg={msg}
                                    dateFormatter={this.dateFormatter}
                                  />
                                );
                              } else {
                                return (
                                  <MessageBox
                                    key={"default_" + index}
                                    position={
                                      msg.owner === "client" ? "left" : "right"
                                    }
                                    title={
                                      msg.owner === "client"
                                        ? undefined
                                        : msg.owner
                                    }
                                    type={"text"}
                                    text={
                                      msg.content
                                        ? msg.content
                                          .split("\n")
                                          .map((line, i) => (
                                            <span key={i}>
                                              {line}
                                              <br />
                                            </span>
                                          ))
                                        : ""
                                    }
                                    dateString={this.dateFormatter(
                                      msg.timestamp
                                    )}
                                    className={`message-container ${msg.owner === "nadubot" ? "naduBotText" : msg.owner === "nadunet" ? "nadunetText" : "clientText"}`}
                                  />
                                );
                              }
                            }
                          }
                        )}
                        {!isAtBottom && (
                          <div
                            style={{
                              position: "absolute",
                              bottom: 78,
                              right: 38,
                            }}
                          >
                            <Tooltip
                              placement="top"
                              title={"Volver al último mensaje"}
                            >
                              <Button
                                shape="circle"
                                icon={<ArrowDownOutlined />}
                                size="large"
                                onClick={this.scrollToBottomChat}
                              />
                            </Tooltip>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%",
                        }}
                      >
                        <h3>Selecciona un chat para comenzar</h3>
                      </div>
                    )}
                    <div ref={this.messagesEndRef} />
                  </div>
                  {selectedUser && usersConversations[selectedUser] && (
                    <div
                      style={{
                        flex: "0 0 auto",
                        width: "100%",
                        padding: "6px 6px 6px 6px",
                        backgroundColor: "#f3f0ea",
                      }}
                    >
                      {!isCurrentUserOwner ? (
                        <Button
                          block
                          type="primary"
                          size="large"
                          className="shadow-md rounded-input"
                          icon={<DownloadOutlined />}
                          loading={this.state.btnLoading.takeOverChat}
                          onClick={() => this.takeOverChat(selectedClient.id)}
                        >
                          Atender cliente
                        </Button>
                      ) : selectedClient.isWritable ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 4,
                          }}
                        >
                          <InputAntd
                            size="large"
                            className="shadow-md rounded-input"
                            placeholder="Escribe tu mensaje"
                            value={newMessage}
                            onChange={this.handleMessageChange}
                            onPressEnter={this.handleSendMessage}
                            disabled={isChatClosed}
                            prefix={
                              <Dropdown
                                trigger={["click"]}
                                placement="top"
                                open={openDropdown}
                                onOpenChange={this.handleOpenChange}
                                menu={{
                                  items: [
                                    {
                                      key: "1",
                                      icon: <FileAddOutlined />,
                                      label: "Adjuntar archivo",
                                      disabled: isChatClosed,
                                      children: [
                                        {
                                          key: "1-1",
                                          icon: <PictureOutlined />,
                                          label: "Imagen",
                                          onClick: () =>
                                            this.handleToggleModalAttachment(
                                              true,
                                              "photo"
                                            ),
                                        },
                                        {
                                          key: "1-2",
                                          icon: <FileOutlined />,
                                          label: "Documento",
                                          onClick: () =>
                                            this.handleToggleModalAttachment(
                                              true,
                                              "file"
                                            ),
                                        },
                                      ],
                                    },
                                    {
                                      key: "2",
                                      icon: <MessageOutlined />,
                                      label: "Enviar plantilla",
                                      children: [
                                        {
                                          key: "2-1",
                                          icon: <ShopOutlined />,
                                          label: "Comercial",
                                          onClick: () =>
                                            this.handleToggleTemplatesModal(
                                              true,
                                              "commercial"
                                            ),
                                        },
                                        {
                                          key: "2-2",
                                          icon: <WalletOutlined />,
                                          label: "Facturación",
                                          onClick: () =>
                                            this.handleToggleTemplatesModal(
                                              true,
                                              "billing"
                                            ),
                                        },
                                        {
                                          key: "2-3",
                                          icon: <TruckOutlined />,
                                          label: "Soporte técnico",
                                          onClick: () =>
                                            this.handleToggleTemplatesModal(
                                              true,
                                              "technician"
                                            ),
                                        },
                                      ],
                                    },
                                  ],
                                }}
                              >
                                <Button
                                  shape="circle"
                                  icon={
                                    <PlusOutlined
                                      style={{
                                        transform: openDropdown
                                          ? "rotate(135deg)"
                                          : "rotate(0deg)",
                                        transition: "transform 0.2s ease",
                                      }}
                                    />
                                  }
                                />
                              </Dropdown>
                            }
                            suffix={
                              //   newMessage.length === 0 ? (
                              //   <Button
                              //     shape="circle"
                              //     icon={<AudioOutlined />}
                              //     // disabled
                              //     className="shadow-md"
                              //   />
                              // ) : (
                              <Button
                                type="primary"
                                shape="circle"
                                disabled={newMessage.length === 0}
                                icon={<SendOutlined />}
                                onClick={this.handleSendMessage}
                                loading={sendingMessageLoading}
                              />
                              // )
                            }
                          />
                        </div>
                      ) : (
                        <Dropdown
                          trigger={["click"]}
                          placement="top"
                          menu={{
                            items: [
                              {
                                key: "1",
                                icon: <ShopOutlined />,
                                label: "Comercial",
                                onClick: () =>
                                  this.handleToggleTemplatesModal(
                                    true,
                                    "commercial",
                                    "meta"
                                  ),
                              },
                              {
                                key: "2",
                                icon: <WalletOutlined />,
                                label: "Facturación",
                                onClick: () =>
                                  this.handleToggleTemplatesModal(
                                    true,
                                    "billing",
                                    "meta"
                                  ),
                              },
                              {
                                key: "3",
                                icon: <TruckOutlined />,
                                label: "Soporte técnico",
                                onClick: () =>
                                  this.handleToggleTemplatesModal(
                                    true,
                                    "technician",
                                    "meta"
                                  ),
                              },
                            ],
                          }}
                        >
                          <Button
                            block
                            type="primary"
                            className="shadow-md rounded-input"
                            size="large"
                            icon={<MessageOutlined />}
                          >
                            Enviar plantilla
                          </Button>
                        </Dropdown>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

export default NaduChat;



// WEBPACK FOOTER //
// ./src/views/NaduChat/NaduChat.jsx